import React from "react";
import { connect } from "react-redux";
import { AppState } from "../../../redux";
import { FormFieldContainer, FormFieldInput } from "../../../react-components/modals/modal-form-elements";
import { SetProfileStateAction, SetProfileStatePayload, ProfileModuleState } from "../redux/profile/types";
import { setProfileState } from "../redux/profile/actions";
import { CompanyCountries } from "../../../constants/company-info";
import { GRAPHQL_TYPE_ENTITY } from "@radivision/graphql";

interface MapStateProps {
  country: string | null;
  isCompany: boolean;
}

interface MapDispatchProps {
  setProfileState: (payload: SetProfileStatePayload) => SetProfileStateAction;
}

export type Props = MapDispatchProps & MapStateProps;

export const Component = (props: Props) => {
  const { country, setProfileState, isCompany } = props;

  if (!isCompany) return null;

  return (
    <FormFieldContainer>
      <label htmlFor="country">
        <span>Country:</span>
      </label>
      <FormFieldInput>
        <select id="country" value={country ? country : ""} onChange={(e) => setProfileState({ country: e.target.value })}>
          <option value={""}>Select country</option>
          {CompanyCountries.map(({ name }) => {
            return (
              <option key={`country-${name}`} value={name}>
                {name}
              </option>
            );
          })}
        </select>
      </FormFieldInput>
    </FormFieldContainer>
  );
};

const mapState = (state: AppState & ProfileModuleState) => {
  return {
    country: state.profile.country,
    isCompany: state.profile.type === GRAPHQL_TYPE_ENTITY,
  };
};

const mapDispatch = {
  setProfileState: setProfileState,
};

export const CompanyCountry = connect(mapState, mapDispatch)(Component);
